import React, { useState, useRef, useEffect } from 'react';
import { User, Settings, LogOut, ChevronDown } from 'lucide-react';

function UserDropdown({ userName, isAdmin, onSettingsClick, onLogoutClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fermer le dropdown au clic extérieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fermer avec Escape
  useEffect(() => {
    function handleEscape(event) {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    }

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  const handleSettingsClick = () => {
    setIsOpen(false);
    onSettingsClick();
  };

  const handleLogoutClick = () => {
    setIsOpen(false);
    onLogoutClick();
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Trigger */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors px-3 py-2 rounded-lg hover:bg-white/10"
      >
        <User className="h-5 w-5 text-gray-400" />
        <span className="text-white">{userName}</span>
        {isAdmin && (
          <span className="text-xs bg-red-500/20 text-red-400 px-2 py-1 rounded-full border border-red-500/30">
            Admin
          </span>
        )}
        <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 glass-deep border border-white/10 rounded-lg shadow-xl z-50 overflow-hidden">
          <div className="py-1">
            <button
              onClick={handleSettingsClick}
              className="flex items-center space-x-3 w-full px-4 py-3 text-left text-gray-300 hover:bg-white/10 hover:text-white transition-colors"
            >
              <Settings className="h-4 w-4" />
              <span>Paramètres du compte</span>
            </button>

            <div className="border-t border-white/10 my-1"></div>

            <button
              onClick={handleLogoutClick}
              className="flex items-center space-x-3 w-full px-4 py-3 text-left text-gray-400 hover:bg-white/10 hover:text-red-400 transition-colors"
            >
              <LogOut className="h-4 w-4" />
              <span>Déconnexion</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserDropdown;
